<template>
  <layout-content>
    <i-button slot="top-buttons" type="primary" size="large" :loading="is_loading" @click="create">
      {{ $t('pbx.breadcrumb.worksheet.create') }}
    </i-button>
    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import TableComponent from '@pbx/components/worksheets/list/table';
  import FilterComponent from '@pbx/components/worksheets/list/filter';
  import { WorksheetService } from '@pbx/services/WorksheetService';
  import { toUserDateWithTime } from '@shared/helpers/date_format';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      TableComponent,
      FilterComponent
    },

    data() {
      return {
        is_loading: false
      };
    },

    computed: {
      ...mapGetters('core/auth', ['user'])
    },

    methods: {
      create: function() {
        this.is_loading = true;

        const form = {
          name: `Virtual PBX. ${toUserDateWithTime(new Date())}`,
          client_id: this.user.id
        };

        WorksheetService.createItem(form)
          .then(worksheet =>
            this.$router.push({ name: 'pbx.worksheet.edit', params: { id: worksheet.id } })
          )
          .finally(() => (this.is_loading = false));
      }
    }
  };
</script>
